import { Component, Input, OnDestroy } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import * as ReportingActions from '@reporting/reporting.actions';

import { Notification } from '@shared/models/Reporting';
import { ReportingService } from '@shared/services/reporting.service';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-risk-recheck-box',
  templateUrl: './risk-recheck-box.component.html',
  styleUrls: ['../super-human-survey-box/super-human-survey-box.component.scss', './risk-recheck-box.component.scss'],
  standalone: false
})
export class RiskRecheckBoxComponent implements OnDestroy {
  @Input() riskRecheck: Notification;

  protected readonly onDestroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private reportingService: ReportingService,
    private trackingService: TrackingService
  ) {}

  trackCTA(action: string): void {
    this.trackingService.trackActivity(action, true);
  }

  ignoreRecheck(): void {
    this.trackCTA('Riskrecheck Survey: [Link] Rejected to start/continue');
    this.reportingService.markAsSeenNotification(this.riskRecheck.id).subscribe((value) => {
      if (value.success === 'success') {
        this.store.dispatch(ReportingActions.getCustomerNotifications());
      }
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
